
<h1 class="titulo">Roles</h1>
<nz-spin [nzSpinning]="loading" nzTip="Cargando..." class="loading-spinner">
<div class="boton-añadir-container">
  <button
    nz-button
    nzType="primary"
    class="excel-button boton-añadir"
    (click)="AddSolicitud()"
  >
    <i nz-icon nzType="plus" nzTheme="outline"></i>
    Añadir Usuario
  </button>
</div>
<div class="tabla-principal">
  <div class="tabla-header-container">
    <div class="tabla-header-left">
      <span class="registros-label"
        >Registros: <strong>{{ usuariosFiltrados?.length }}</strong></span
      >
    </div>
  </div>

  <div class="search-container search-input-full">
    <nz-input-group nzSuffixIcon="search" class="">
      <input
        type="text"
        nz-input
        placeholder="Buscar por ID o Nombre.."
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange($event)"
      />
    </nz-input-group>
  </div>

  <nz-spin [nzSpinning]="loading">
  <nz-table
    #basicTable
    [nzData]="usuariosFiltrados || []"
    class="tabla-colaboradores"
    [nzScroll]="{ x: '1400px' }"
  >
    <thead>
      <tr>
        <th nzWidth="150px" class="bold">Acciones</th>
        <th class="bold">Email</th>
        <th class="bold">Rol</th>
        <th class="bold">Sociedad</th>
        <th class="bold">Estatus</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let usuario of basicTable.data">
        <td>
          <div class="acciones-container">
            <img
                    src="assets/icon/edit.svg"
                    class="icono-sgmm"
                    style="cursor: pointer;"
                    alt="icono sgmm"
                    (click)="editarUsuario(usuario)"
                  />
                  <img
                    src="assets/icon/trash.svg"
                    class="icono-sgmm"
                    style="cursor: pointer;"
                    alt="icono sgmm"
                    nz-popconfirm
                    [nzPopconfirmTitle]="'¿Estás seguro de eliminar al usuario ' + usuario.email + '?'"
                    nzPopconfirmPlacement="top"
                    nzOkText="Sí, eliminar"
                    nzCancelText="Cancelar"
                    nzOkType="danger"
                    (nzOnConfirm)="eliminarUsuario(usuario)"
                  />
          </div>
        </td>
        <td class="row">{{ usuario.email }}</td>
        <td class="row">{{ usuario.rol }}</td>
        <td class="row">{{ usuario.sociedad || "N/A" }}</td>
        <td class="row">
          <nz-tag [nzColor]="usuario.activo ? 'green' : 'red'">
            {{ usuario.activo ? "Activo" : "Inactivo" }}
          </nz-tag>
        </td>
      </tr>
    </tbody>
  </nz-table>
  </nz-spin>
</div>
</nz-spin>
